import { paymentMethodName, type PaymentMethodLike } from '../shared/billing-format';

type PaymentMethodTextProps = {
  method: PaymentMethodLike;
};

/** "Visa ending in 9308" with the digits in mono, "Link · owner@x.test", or just "Cash App Pay". */
export const PaymentMethodText = ({ method }: PaymentMethodTextProps) => (
  <>
    {paymentMethodName(method)}
    {method.last4 ? (
      <>
        {' '}
        ending in <span className="font-mono">{method.last4}</span>
      </>
    ) : method.email ? (
      <> · {method.email}</>
    ) : null}
  </>
);
